module.exports = __webpack_public_path__ + "static/media/Warren Buffett.0c14234a.jpg";